import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { SiteSearchModalComponent } from './site-search-modal.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FgTypeaheadModule, FgTypeaheadComponent } from '../fg-typeahead/';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatDialogModule,
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        FgTypeaheadModule
    ],
    exports: [
        SiteSearchModalComponent
    ],
    declarations: [
        SiteSearchModalComponent
    ],
    entryComponents: [FgTypeaheadComponent],
    providers: []
})
export class SiteSearchModalModule { }
